export const PROJECT_TYPE_DISPLAY_PLACE = { CARD: "CARD", OTHER: "OTHER" };
export const ANSWER_TYPE = {
  NUMBER: "NUMBER",
  SHORT_TEXT: "SHORT_TEXT",
  SINGLE_CHOICE: "SINGLE_CHOICE",
  MULTI_CHOICE: "MULTI_CHOICE",
  YES_NO: "YES_NO",
};
export const BUDGET_TIER = {
  UNDER_50: "UNDER_50",
  FROM_50_TO_100: "FROM_50_TO_100",
  FROM_100_TO_200: "FROM_100_TO_200",
  OVER_200: "OVER_200",
};
export const BUDGET_TIER_LABEL = {
  UNDER_50: "Dưới 50 triệu",
  FROM_50_TO_100: "50 – 100 triệu",
  FROM_100_TO_200: "100 – 200 triệu",
  OVER_200: "Trên 200 triệu",
};
export const ERROR_CODE = Object.fromEntries(
  [
    "VALIDATION_ERROR",
    "QUESTION_OPTIONS_REQUIRED",
    "QUESTION_OPTIONS_DUPLICATED",
    "PACKAGE_PRICE_REQUIRED",
    "PACKAGE_PRICE_RANGE_INVALID",
    "PACKAGE_PRODUCT_DUPLICATED",
    "PACKAGE_QUANTITY_INVALID",
    "FORBIDDEN",
    "NOT_FOUND",
    "UNAUTHENTICATED",
    "PROJECT_TYPE_NAME_DUPLICATED",
    "PACKAGE_TIER_ALREADY_VISIBLE",
  ].map((code) => [code, code])
);
export const PAGE_SIZE_DEFAULT = 20;
export const PAGE_SIZE_MAX = 100;
